<template>
  <div class="footer">
    <div class="fd-top">
      <div class="fd-lk">
        <div class="wp">
          <a href="list-30-1.html" target="_blank">品牌咨询策划</a>
          <a href="list-32-1.html" target="_blank">产品营销策划</a>
          <a href="list-31-1.html" target="_blank">视觉创意设计</a>
          <a href="list-33-1.html" target="_blank">数字互动行销</a>
          <a href="list-35-1.html" target="_blank">视频创意制作</a>
          <a href="list-74-1.html" target="_blank">ci设计</a>
          <a href="planing/index.html" target="_blank">豪禾品牌资讯</a>
          <a href="brand/index.html" target="_blank">品牌定位</a>
          <a href="b2b/index.html" target="_blank">B2B品牌战略</a>
          <a class="last" href="jiancai/index.html" target="_blank">建材品牌建设</a>
        </div>
      </div>
    </div>
    <div class="fd-con">
      <div class="wp">
        <div class="fd-lk2">
          <div class="con">
            <dl>
              <dd>
                <a href="brand/brand/index.html">品牌策划</a>
                <a href="brand/index.html">品牌定位</a>
                <a href="brand/brandnews/index.html">品牌命名</a>
                <a href="brand/brand/index.html">品牌诊断</a>
                <a href="brand/brandnews/index.html">品牌故事</a>
                <a href="brand/brandnews/index.html">品牌口号</a>
                <a href="pinpai/building/index.html">企业文化建设</a>
              </dd>
            </dl>
            <dl>
              <dd>
                <a href="case/index.html">创意设计</a>
                <a href="case/logo/index.html">Logo/VI设计</a>
                <a href="case/catalog/index.html">定制画册设计</a>
                <a href="case/jixiangwu/index.html">创意吉祥物设计</a>
                <a href="case/pakcgeing/index.html">创意包装设计</a>
                <a href="case/web/index.html">创意网站设计</a>
                <a href="case/sidesign/index.html">创意空间/SI设计</a>
                <a href="case/sign/index.html">导视设计</a>
              </dd>
            </dl>
            <dl>
              <dd>
                <a href="#">品牌延展</a>
                <a href="list-34-1.html">公关策划执行</a>
                <a href="case/Animation/index.html">主题活动资源</a>
                <a href="list-32-1.html">产品营销策划</a>
                <a href="list-30-1.html">品牌物料制作</a>
                <a href="brand/index.html">新媒体推广</a>
              </dd>
            </dl>
            <dl>
              <dd>
                <a href="planing/index.html">品牌资讯</a>
                <a href="about1/index.html">设计前沿</a>
                <a href="Design/index.html">时尚热点</a>
                <a href="pinpaibaike/index.html">品牌百科</a>
                <a href="guanggaowenda/index.html">广告Q＆A</a>
                <a href="about2/index.html">豪禾动态</a>
                <a href="case/bz/index.html">口罩包装设计</a>
              </dd>
            </dl>
            <dl>
              <dd>
                <a href="contact/index.html">联系豪禾</a>
                <a href="about/index.html">关于豪禾</a>
                <a href="about/SELECT/index.html">选择豪禾</a>
                <a href="job/index.html">豪禾招聘</a>
                <a href="sitemaps.html">网站地图</a>
                <a href="special/sitemaps.html">专题地图</a>
              </dd>
            </dl>
          </div>
        </div>
        <div class="fd-imgtxt">
          <div class="qr">
            <img src="/statics/images/ico-g2.html" alt="易企画品牌咨询微信" />
          </div>
          <h4>易企画品牌咨询</h4>
          <p class="tel">tel：13606083580</p>
        </div>
      </div>
    </div>
    <div class="fd-copy">
      <div class="wp">
        <p class="p-hstxt">
          厦门易企画品牌咨询有限公司（厦门品牌设计公司） <br />
          地址：厦门市翔安区ABB工业中心8号门斜对面
        </p>
        <div class="ft-hide">
          <p>
            厦门易企画品牌咨询有限公司（厦门品牌设计公司） TEL:13606083580 <br />
            地址：厦门市翔安区ABB工业中心8号门斜对面
          </p>
          <p>
            <a href="special/index.html">品牌设计专题</a>:
            <a href="special/visheji/index.html">VI设计</a>|
            <a href="special/pinpai/index.html">品牌策划</a>|
            <a href="special/pinpaisheji/index.html">品牌设计</a>|
            <a href="special/logosheji/index.html">logo设计</a>|
            <a href="special/biaozhisheji/index.html">标志设计</a>|
            <a href="special/shangbiaosheji/index.html">商标设计</a>|
            <a href="special/huacesheji/index.html">画册设计</a>|
            <a href="special/xuanchuancesheji/index.html">宣传册设计</a>
          </p>
          <p>
            服务行业：
            <a href="shandong/index.html">易企画品牌咨询厦门公司</a>｜
            <a href="case/service/index.html">服务业vi设计</a>｜
            <a href="case/fastsell/index.html">快消品VI设计</a>｜
            <a href="case/realty/index.html">房地产品牌设计</a>｜
            <a href="case/medical/index.html">医疗医药VI设计</a>｜
            <a href="case/business/index.html">商业金融品牌设计</a>｜
            <a href="case/manufacture/index.html">生产制造企业logo设计</a>｜
            <a href="case/culture/index.html">文化艺术形象设计</a>
          </p>
        </div>
        <p>
          Copyright © 2005-2018 www.haohead.com <br />
          All Rights Reserved<br />
          <a href="http://www.beian.miit.gov.cn/">沪公网安备 31010402001420号</a>
          <br />
          <a href="https://beian.miit.gov.cn/" rel="nofollow"> 沪ICP备11050230号-42</a>
        </p>
      </div>
    </div>
    <div class="fd-lk3">
      <div class="wp">
        <div class="lk">
          <a href="https://www.lookpack.cn/">上海饮料包装设计</a><em>|</em>
          <a href="https://hotel.haohe.cn/">酒店VI设计</a><em>|</em>
          <a href="https://www.junzan.com/">画册设计公司</a><em>|</em>
          <a href="https://canyin.haohe.cn/">餐饮品牌设计</a><em>|</em>
          <a href="https://www.sh133.cn/">上海印刷公司</a><em>|</em>
          <a href="https://www.lookbrand.com.cn/">上海logo设计公司</a><em>|</em>
          <a href="2020/logo_0928/861.html">健康行业品牌设计</a><em>|</em>
          <a href="pinpai/building/index.html">品牌文化建设</a><em>|</em>
          <a href="case/canyin/index.html">餐饮品牌设计</a><em>|</em>
          <a href="https://www.goobai.com/">logo设计</a><em>|</em>
          <a href="shandong/index.html">豪禾山东分公司</a><em>|</em>
          <a href="http://www.sz4a.cn/">深圳vi设计</a><em>|</em>
          <a href="https://www.2898.com/">站长资源平台</a><em>|</em>
          <a href="planing/mzsj/index.html">化妆品设计</a><em>|</em>
          <a href="https://www.17font.com/">字体视界</a><em>|</em>
          <a href="case/Animation/index.html">二维动画制作公司</a><em>|</em>
          <a href="https://www.yituyu.com/">艺图语</a><em>|</em>
          <a href="http://www.cndesign.com/">中国设计网 </a><em>|</em>
          <a href="http://www.cgmodel.com/">CG模型网</a><em>|</em>
          <a href="http://www.moxingyun.com/">3d模型网</a><em>|</em>
          <a href="http://90sheji.com/">90设计</a><em>|</em>
          <a href="http://www.5tu.cn/">百图汇素材网</a><em>|</em>
          <a href="http://www.logosc.cn/">标小智LOGO神器</a><em>|</em>
          <a href="http://www.lfppt.com/">PPT模板</a><em>|</em>
          <a href="https://www.fotor.com.cn/">平面设计软件</a><em>|</em>
          <a href="https://www.huiyi8.com/">素材</a><em>|</em>
          <a href="http://www.gbicom.cn/">商标网</a><em>|</em>
          <a href="https://www.doooor.com/">DOOOOR设计网</a><em>|</em>
          <a href="http://www.333cn.com/">中国设计之窗</a><em>|</em>
          <a href="https://www.qmxip.com/">商标注册</a><em>|</em>
          <a href="https://www.4vi.cn/">包装设计公司</a><em>|</em>
          <a href="http://www.vevb.com/">武林网</a><em>|</em>
          <a href="https://www.sh133.cn/tnews/">印刷百科</a><em>|</em>
          <a href="http://www.zjdengbao.com/">登报声明</a><em>|</em>
          <a href="https://www.haohead.cn/">上海品牌设计公司</a><em>|</em>
          <a href="https://jiangmousheji.com/">杭州VI设计</a><em>|</em>
          <a href="index-2.html">友情链接QQ：370069545</a><em>|</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #191919;
  overflow: hidden;
  width: 100%;
}

.fd-top {
  background-color: #242526;
}

.fd-lk {
  padding: 25.5px 0;
  border-bottom: 1px solid #EA4043;
  font-size: 0;
  text-align: center;
}

.fd-lk .wp {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
}

.fd-lk a {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  color: #ccc;
  line-height: 40px;
  padding: 0 15px 0 15px;
  position: relative;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  text-decoration: none;
}

.fd-lk a:after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  width: 1px;
  height: 16px;
  margin-top: -8px;
  background-color: #ccc;
}

.fd-lk a.last:after {
  display: none;
}

.fd-lk a:hover {
  color: #fff;
}

.fd-con {
  padding: 34px 0;
  overflow: hidden;
}

.fd-con .wp {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
}

.fd-lk2 {
  float: left;
  width: 78%;
  overflow: hidden;
}

.fd-lk2 .con {
  margin: 0 -40px;
  overflow: hidden;
}

.fd-lk2 dl {
  float: left;
  padding: 0 50px;
  margin-top: -6px;
  border-left: 1px solid #3d3d3d;
}

.fd-lk2 dl:first-child {
  border-left: none;
}

.fd-lk2 dd {
  overflow: hidden;
  margin: 0;
  padding: 0;
  list-style: none;
}

.fd-lk2 dd a {
  display: block;
  font-size: 16px;
  color: #ccc;
  line-height: 30px;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  text-decoration: none;
}

.fd-lk2 dd a:hover {
  color: #fff;
}

.fd-imgtxt {
  float: right;
  max-width: 22%;
  padding-top: 17px;
  text-align: center;
}

.fd-imgtxt .qr {
  width: 141px;
  height: 141px;
  margin: 0 auto 15px;
  overflow: hidden;
}

.fd-imgtxt .qr img {
  display: block;
  width: 100%;
  height: 100%;
}

.fd-imgtxt h4 {
  font-size: 16px;
  color: #ccc;
  line-height: 1.4;
  text-align: center;
  font-weight: 400;
  margin-bottom: 15px;
  margin-top: 0;
}

.fd-imgtxt .tel {
  font-size: 24px;
  color: #EA4043;
  line-height: 1.4;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.7px;
  margin: 0;
}

.fd-copy {
  padding: 30px 0 24px;
  font-size: 14px;
  color: #ccc;
  line-height: 30px;
  text-align: center;
  border-bottom: 1px solid #3d3d3d;
}

.fd-copy .wp {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
}

.fd-copy br {
  display: none;
}

.fd-copy .p-hstxt {
  color: #ccc;
  font-size: 14px;
  line-height: 30px;
  margin-bottom: 0;
}

.fd-copy .ft-hide {
  display: none;
}

.fd-copy p {
  color: #ccc;
  font-size: 14px;
  line-height: 30px;
  margin: 0;
}

.fd-copy a {
  color: #ccc;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  text-decoration: none;
}

.fd-copy a:hover {
  color: #fff;
}

.fd-lk3 {
  padding: 26px 0 36px;
  overflow: hidden;
  background: #191919;
}

.fd-lk3 .wp {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
}

.fd-lk3 .lk {
  margin-bottom: 10px;
  font-size: 0;
  overflow: hidden;
  text-align: center;
}

.fd-lk3 .lk a {
  font-size: 14px;
  color: #ccc;
  line-height: 30px;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  text-decoration: none;
}

.fd-lk3 .lk a:hover {
  color: #fff;
}

.fd-lk3 .lk em {
  font-size: 14px;
  color: #ccc;
  line-height: 30px;
  margin: 0 4px 0 6px;
}

/* 清除浮动 */
.fd-con .wp::after,
.fd-lk2 .con::after {
  content: '';
  display: table;
  clear: both;
}

@media (max-width: 1200px) {
  .fd-lk {
    text-align: left;
  }

  .fd-lk .wp {
    padding: 0;
  }

  .fd-con .wp,
  .fd-copy .wp,
  .fd-lk3 .wp {
    padding: 0 20px;
  }

  .fd-lk2 {
    float: none;
    width: auto;
  }

  .fd-lk2 .con {
    margin: 0 -2%;
  }

  .fd-lk2 dl {
    padding: 0 3%;
    width: 20%;
  }

  .fd-imgtxt {
    float: none;
    max-width: none;
  }

  .fd-copy br {
    display: block;
  }

  .fd-lk .wp,
  .fd-con .wp,
  .fd-copy .wp,
  .fd-lk3 .wp {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .fd-lk {
    padding: 10px 0;
  }

  .fd-lk a {
    font-size: 14px;
    line-height: 24px;
    padding: 0 12px;
  }

  .fd-lk a:after {
    height: 8px;
    margin-top: -4px;
  }

  .fd-con {
    padding: 15px 0;
  }

  .fd-con .wp {
    padding: 0 10px;
  }

  .fd-copy .wp,
  .fd-lk3 .wp {
    padding: 0 10px;
  }

  .fd-lk2 {
    margin: 0;
  }

  .fd-lk2 dl {
    margin-top: 0;
    padding: 0 2%;
  }

  .fd-lk2 dd a {
    font-size: 12px;
    line-height: 20px;
  }

  .fd-imgtxt .qr {
    width: 70px;
    height: 70px;
    margin-bottom: 8px;
  }

  .fd-imgtxt h4 {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .fd-imgtxt .tel {
    font-size: 14px;
  }

  .fd-copy {
    font-size: 14px;
    line-height: 20px;
  }

  .fd-lk3 {
    display: none;
  }

  .fd-imgtxt .tel,
  .fd-lk2,
  .ft-hide {
    display: none;
  }
}
</style>